import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@/components/ui/skeleton';
import { useSamples } from '@/services/sample.service';
import ExportForm from './ExportForm';

/** The project's exports, over one or more of its samples. */
export default function ExportTab() {
    const { projectId } = useParams();
    const { t } = useTranslation();
    const { data: samples, isLoading } = useSamples(projectId);

    if (isLoading) return <Skeleton className="w-full h-[300px] rounded-lg" />;

    if (!projectId || !samples || samples.length === 0)
        return (
            <div className="text-center py-16 bg-white border border-dashed border-[#dadbd5] rounded-lg text-sm text-[#7a8077]">
                {t('No samples to export.')}
            </div>
        );

    const sorted = [...samples].sort((a, b) => a.name.localeCompare(b.name));
    return <ExportForm projectId={projectId} samples={sorted} />;
}
